module.exports = __webpack_public_path__ + "static/media/md-keypad.7afd336c.svg";